import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { Text } from "@sitecore-jss/sitecore-jss-react";
import EmailInput from "@clarion/foundation/dist/Helpers/components/Forms/EmailInput";
import ModalLoader from "@clarion/foundation/dist/Helpers/components/ModalLoader";
import GlobalErrorComponent from "@clarion/foundation/dist/Helpers/components/Forms/GlobalErrorComponent";
import { userDataApiCall } from "@clarion/foundation/dist/Utils/apiUtils";
import { invalidFieldError } from "@clarion/foundation/dist/Settings/constants/forms";
const EmailEntryStep = ({
  fields,
  rendering,
  t,
  proceedToNextStep
}) => {
  const {
    register,
    handleSubmit,
    errors
  } = useForm();
  const requiredLabel = t("FieldRequired");
  const emailLabel = t("EmailAddress");
  const global = useSelector(state => state.global);
  const [email, setEmail] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showError, setShowError] = useState(false);
  const emailFieldName = "Email";
  const emailRegex = new RegExp(fields?.RegexSettings.fields.Email?.value);
  const serviceCall = data => {
    userDataApiCall("/api/account/unlock-account-modal-send-verification-email", rendering, data).then(() => {
      proceedToNextStep();
    }).catch(() => {
      setShowError(true);
    }).finally(() => {
      setShowLoader(false);
      window.sessionStorage.removeItem("loginEmail");
    });
  };
  const onSubmit = data => {
    const payload = {
      Email: data[emailFieldName]
    };
    setShowLoader(true);
    setShowError(false);
    setTimeout(() => serviceCall(payload), 500); // Delay service call to ensure loader always displays
  };
  useEffect(() => {
    if (window.sessionStorage.loginEmail) {
      setEmail(window.sessionStorage.loginEmail);
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, showLoader && /*#__PURE__*/React.createElement(ModalLoader, {
    label: fields.ModalLoadingLabel?.value
  }), /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: `account__header ${showLoader ? "account--hide" : ""}`,
    field: fields.EnterEmailStepTitle
  }), /*#__PURE__*/React.createElement("form", {
    className: `${showLoader ? "account--hide" : ""}`,
    onSubmit: handleSubmit(onSubmit)
  }, showError && /*#__PURE__*/React.createElement(GlobalErrorComponent, {
    title: fields.ErrorTitle?.value,
    message: fields.ErrorDescription?.value
  }), /*#__PURE__*/React.createElement(EmailInput, {
    ref: register({
      required: requiredLabel,
      pattern: {
        value: emailRegex,
        message: fields?.RegexSettings.fields.EmailError?.value || invalidFieldError
      }
    }),
    autoFocus: !global.isTablet,
    isRequired: true,
    isGeneric: false,
    fieldName: emailFieldName,
    defaultValue: email,
    labelName: emailLabel,
    placeholder: fields.EnterEmailStepPlaceholderEmail?.value,
    id: "unlock-account-email-field",
    errors: errors[emailFieldName]
  }), /*#__PURE__*/React.createElement("button", {
    className: `btn account__btn ${showLoader ? "account--hide" : ""}`,
    type: "submit"
  }, fields.EnterEmailStepCTAText?.value)));
};
export default withTranslation()(EmailEntryStep);